export default __webpack_public_path__ + "static/envelope-fe761739852055fd047fac69a4dd922b.png";